import {
  Pilcrow,
  Heading1,
  Heading2,
  Image as ImageIcon,
  Video as VideoIcon,
  Images,
  MousePointerClick,
  Link2,
  Table as TableIcon,
  ListOrdered,
  Quote as QuoteIcon,
  AlertTriangle,
  Code2,
  Minus,
  File as FileIcon,
  HelpCircle,
  MoveVertical,
  TextCursorInput,
  AlignJustify,
  ChevronsUpDown,
  CheckSquare,
  CalendarDays,
  Circle,
  ToggleLeft,
  FileInput,
  ListChecks,
  Sparkles,
  BarChart3,
  TrendingUp,
  Star,
  Box,
  Columns,
  Rows,
  LayoutTemplate,
  PanelTop,
  GalleryHorizontalEnd,
} from "lucide-react";
import { elakayAutoText } from "../dataElakay";


export const generateBlockId = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return `blk_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
};

// Single source of truth for the 16 block types: icon, i18n label key/fallback,
// and the default content/settings shape a freshly-added block starts with.
// Mirrors BLOCK_TYPES in server_elakay/elakay_models/howWeDoIt.js — kept in
// sync manually, there is no shared schema layer between front/back here.
export const BLOCK_TYPES = [
  {
    type: "title",
    icon: Heading1,
    labelKey: "howWeDoIt_block_title",
    get label() { return elakayAutoText("h_eb97899aedcd56", "Titre"); },
    defaultContent: () => ({ text: "" }),
    defaultSettings: () => ({ level: 1, align: "left" }),
  },
  {
    type: "subtitle",
    icon: Heading2,
    labelKey: "howWeDoIt_block_subtitle",
    get label() { return elakayAutoText("h_8657e88f4bf4b2", "Sous-titre"); },
    defaultContent: () => ({ text: "" }),
    defaultSettings: () => ({ align: "left" }),
  },
  {
    type: "text",
    icon: Pilcrow,
    labelKey: "howWeDoIt_block_text",
    get label() { return elakayAutoText("h_ff9afef1eae0a9", "Texte"); },
    defaultContent: () => ({ html: "<p></p>" }),
    defaultSettings: () => ({}),
  },
  {
    type: "image",
    icon: ImageIcon,
    labelKey: "howWeDoIt_block_image",
    get label() { return elakayAutoText("h_50e19fda0d5b4b", "Image"); },
    defaultContent: () => ({ url: "", alt: "", caption: "" }),
    defaultSettings: () => ({
      width: "",
      height: "",
      align: "center",
      borderRadius: 0,
      shadow: false,
      linkUrl: "",
    }),
  },
  {
    type: "video",
    icon: VideoIcon,
    labelKey: "howWeDoIt_block_video",
    get label() { return elakayAutoText("h_bc17c1f0179a88", "Video"); },
    defaultContent: () => ({ source: "youtube", url: "", thumbnail: "", title: "", description: "" }),
    defaultSettings: () => ({ autoplay: false, controls: true, muted: false, aspectRatio: "16:9" }),
  },
  {
    type: "gallery",
    icon: Images,
    labelKey: "howWeDoIt_block_gallery",
    get label() { return elakayAutoText("h_1e88ec32fff722", "Galerie"); },
    defaultContent: () => ({ items: [] }),
    defaultSettings: () => ({ columns: 3, align: "center" }),
  },
  {
    type: "button",
    icon: MousePointerClick,
    labelKey: "howWeDoIt_block_button",
    get label() { return elakayAutoText("h_fd5aea7172cc0a", "Bouton"); },
    defaultContent: () => ({ label: "", url: "" }),
    defaultSettings: () => ({ style: "primary", align: "left", openInNewTab: false }),
  },
  {
    type: "link",
    icon: Link2,
    labelKey: "howWeDoIt_block_link",
    get label() { return elakayAutoText("h_e2639e1dc1de80", "Lien"); },
    defaultContent: () => ({ label: "", url: "", description: "" }),
    defaultSettings: () => ({ openInNewTab: true }),
  },
  {
    type: "table",
    icon: TableIcon,
    labelKey: "howWeDoIt_block_table",
    get label() { return elakayAutoText("h_bb6d7e523007fb", "Tableau"); },
    defaultContent: () => ({ headers: ["Colonne 1", "Colonne 2"], rows: [["", ""]] }),
    defaultSettings: () => ({ striped: true, bordered: true }),
  },
  {
    type: "steps",
    icon: ListOrdered,
    labelKey: "howWeDoIt_block_steps",
    get label() { return elakayAutoText("h_26a7fffc1930b9", "Etapes"); },
    defaultContent: () => ({ items: [{ title: "", description: "", image: "" }] }),
    defaultSettings: () => ({ numbered: true }),
  },
  {
    type: "quote",
    icon: QuoteIcon,
    labelKey: "howWeDoIt_block_quote",
    get label() { return elakayAutoText("h_6eb49155521358", "Citation"); },
    defaultContent: () => ({ text: "", author: "" }),
    defaultSettings: () => ({ style: "default" }),
  },
  {
    type: "alert",
    icon: AlertTriangle,
    labelKey: "howWeDoIt_block_alert",
    get label() { return elakayAutoText("h_672e2f601f7a92", "Alerte"); },
    defaultContent: () => ({ text: "" }),
    defaultSettings: () => ({ variant: "info" }),
  },
  {
    type: "code",
    icon: Code2,
    labelKey: "howWeDoIt_block_code",
    get label() { return elakayAutoText("h_adac69379a626c", "Code"); },
    defaultContent: () => ({ code: "", language: "javascript" }),
    defaultSettings: () => ({ showLineNumbers: true }),
  },
  {
    type: "divider",
    icon: Minus,
    labelKey: "howWeDoIt_block_divider",
    get label() { return elakayAutoText("h_a72d565f202085", "Separateur"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({ style: "solid", spacing: "md" }),
  },
  {
    type: "file",
    icon: FileIcon,
    labelKey: "howWeDoIt_block_file",
    get label() { return elakayAutoText("h_f0fa5745ccc974", "Fichier"); },
    defaultContent: () => ({ url: "", filename: "", size: 0, mimeType: "" }),
    defaultSettings: () => ({ showFileSize: true }),
  },
  {
    type: "faq",
    icon: HelpCircle,
    labelKey: "howWeDoIt_block_faq",
    label: "FAQ",
    defaultContent: () => ({ items: [{ question: "", answer: "" }] }),
    defaultSettings: () => ({ defaultOpenFirst: true }),
  },

  // ---------------------------------------------------------------------------
  // Elementary elements imported from Page Builder (layout/form/media/data
  // groups only). Form-field types render as read-only styled mockups — How We
  // Do It has no form-submission backend, so they illustrate a field's look
  // without collecting real input.
  // ---------------------------------------------------------------------------
  {
    type: "spacer",
    icon: MoveVertical,
    labelKey: "howWeDoIt_block_spacer",
    get label() { return elakayAutoText("h_e0a35ec4d2a004", "Espacement"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({ height: "40px" }),
  },
  {
    type: "input",
    icon: TextCursorInput,
    labelKey: "howWeDoIt_block_input",
    get label() { return elakayAutoText("h_67d0c143fd436e", "Champ texte"); },
    defaultContent: () => ({ label: "", placeholder: "" }),
    defaultSettings: () => ({ inputType: "text" }),
  },
  {
    type: "textarea",
    icon: AlignJustify,
    labelKey: "howWeDoIt_block_textarea",
    get label() { return elakayAutoText("h_e5d83ebaf6321d", "Zone de texte"); },
    defaultContent: () => ({ label: "", placeholder: "" }),
    defaultSettings: () => ({ rows: 4 }),
  },
  {
    type: "select",
    icon: ChevronsUpDown,
    labelKey: "howWeDoIt_block_select",
    get label() { return elakayAutoText("h_85021c1868fe8c", "Menu deroulant"); },
    defaultContent: () => ({ label: "", choices: ["Option 1", "Option 2", "Option 3"] }),
    defaultSettings: () => ({}),
  },
  {
    type: "checkbox",
    icon: CheckSquare,
    labelKey: "howWeDoIt_block_checkbox",
    get label() { return elakayAutoText("h_98b489cb7e3880", "Case a cocher"); },
    defaultContent: () => ({ label: "" }),
    defaultSettings: () => ({ checked: false }),
  },
  {
    type: "datefield",
    icon: CalendarDays,
    labelKey: "howWeDoIt_block_datefield",
    get label() { return elakayAutoText("h_387a1d23ae83d7", "Champ date"); },
    defaultContent: () => ({ label: "" }),
    defaultSettings: () => ({}),
  },
  {
    type: "radio",
    icon: Circle,
    labelKey: "howWeDoIt_block_radio",
    get label() { return elakayAutoText("h_3fbab28f35b6b8", "Bouton radio"); },
    defaultContent: () => ({ label: "", name: "group1", value: "option1" }),
    defaultSettings: () => ({ checked: false }),
  },
  {
    type: "toggle",
    icon: ToggleLeft,
    labelKey: "howWeDoIt_block_toggle",
    get label() { return elakayAutoText("h_54c9be223abcb2", "Interrupteur"); },
    defaultContent: () => ({ label: "" }),
    defaultSettings: () => ({ checked: false }),
  },
  {
    type: "output",
    icon: FileInput,
    labelKey: "howWeDoIt_block_output",
    get label() { return elakayAutoText("h_c9f6c1d0fd155b", "Resultat"); },
    defaultContent: () => ({ text: "" }),
    defaultSettings: () => ({}),
  },
  {
    type: "datalist",
    icon: ListChecks,
    labelKey: "howWeDoIt_block_datalist",
    get label() { return elakayAutoText("h_03465511e590e5", "Champ + suggestions"); },
    defaultContent: () => ({ label: "", placeholder: "", choices: ["Suggestion 1", "Suggestion 2", "Suggestion 3"] }),
    defaultSettings: () => ({}),
  },
  {
    type: "icon",
    icon: Sparkles,
    labelKey: "howWeDoIt_block_icon",
    get label() { return elakayAutoText("h_0793f02610b67f", "Icone"); },
    defaultContent: () => ({ glyph: "★" }),
    defaultSettings: () => ({ size: "48px" }),
  },
  {
    type: "stat",
    icon: BarChart3,
    labelKey: "howWeDoIt_block_stat",
    get label() { return elakayAutoText("h_ad2bc543bcec51", "Statistique"); },
    defaultContent: () => ({ value: "", label: "" }),
    defaultSettings: () => ({}),
  },
  {
    type: "progress",
    icon: TrendingUp,
    labelKey: "howWeDoIt_block_progress",
    get label() { return elakayAutoText("h_685e262241d88a", "Progression"); },
    defaultContent: () => ({ label: "", percent: 50 }),
    defaultSettings: () => ({}),
  },
  {
    type: "rating",
    icon: Star,
    labelKey: "howWeDoIt_block_rating",
    get label() { return elakayAutoText("h_7238f6a96af1a5", "Note (etoiles)"); },
    defaultContent: () => ({ value: 4, max: 5, label: "" }),
    defaultSettings: () => ({}),
  },
  {
    // Swiper Manager swiper, embedded by reference (never copied): same
    // renderer as every Elakay page.
    type: "elakaySwiper",
    icon: GalleryHorizontalEnd,
    labelKey: "howWeDoIt_block_elakaySwiper",
    get label() { return elakayAutoText("h_esb_label", "Elakay Swiper"); },
    defaultContent: () => ({ swiperId: "", swiperName: "" }),
    defaultSettings: () => ({ maxWidth: 0 }),
  },

  // ---------------------------------------------------------------------------
  // Layout/container elements imported from Page Builder. Purely visual
  // grouping wrappers — their content lives entirely in their nested children
  // (one level, same cap as every other block type), added via the same
  // "Add nested block" action already available on every block card.
  // ---------------------------------------------------------------------------
  {
    type: "container",
    icon: Box,
    labelKey: "howWeDoIt_block_container",
    get label() { return elakayAutoText("h_a33d642c1d8348", "Conteneur"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({}),
  },
  {
    type: "row",
    icon: Columns,
    labelKey: "howWeDoIt_block_row",
    get label() { return elakayAutoText("h_53a2544cacfd92", "Colonnes"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({ columns: 2 }),
  },
  {
    type: "stack",
    icon: Rows,
    labelKey: "howWeDoIt_block_stack",
    get label() { return elakayAutoText("h_25d4a08572166d", "Pile verticale"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({}),
  },
  {
    type: "section",
    icon: LayoutTemplate,
    labelKey: "howWeDoIt_block_section",
    get label() { return elakayAutoText("h_7854785a1428da", "Section pleine"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({}),
  },
  {
    type: "panel",
    icon: PanelTop,
    labelKey: "howWeDoIt_block_panel",
    get label() { return elakayAutoText("h_2bd68b3301988c", "Panneau ombre"); },
    defaultContent: () => ({}),
    defaultSettings: () => ({}),
  },
];

const BLOCK_TYPE_MAP = BLOCK_TYPES.reduce((map, def) => {
  map[def.type] = def;
  return map;
}, {});

export const getBlockDefinition = (type) => BLOCK_TYPE_MAP[type] || BLOCK_TYPE_MAP.text;

export const createBlock = (type) => {
  const def = getBlockDefinition(type);
  return {
    blockId: generateBlockId(),
    type: def.type,
    order: 0,
    visible: true,
    content: def.defaultContent(),
    settings: def.defaultSettings(),
    children: [],
  };
};

// Children share every block's own creation logic but never carry a `children`
// field themselves — this is what keeps nesting capped at one level on the
// frontend, matching the backend's ChildBlockSchema.
export const createChildBlock = (type) => {
  const block = createBlock(type);
  delete block.children;
  return block;
};
